[
  {
    "id": -1,
    "description": "Inkasný blok",
    "textToTranslate": "payment-source.cash"
  },
  null,
  {
    "id": 1,
    "description": "Banka",
    "textToTranslate": "payment-source.bank-transfer"
  },
  {
    "id": 2,
    "description": "Poštová banka - ePoukaz",
    "textToTranslate": "payment-source.epostal-order"
  },
  {
    "id": 3,
    "description": "VAKUP",
    "textToTranslate": "payment-source.postal-order"
  },
  {
    "id": 4,
    "description": "SPORO",
    "textToTranslate": "payment-source.bank-transfer"
  },
  {
    "id": 5,
    "description": "Poštová banka",
    "textToTranslate": "payment-source.bank-transfer"
  },
  {
    "id": 6,
    "description": "Pokladňa",
    "textToTranslate": "payment-source.cash"
  },
  {
    "id": 7,
    "description": "Citibank",
    "textToTranslate": "payment-source.bank-transfer"
  },
  {
    "id": 8,
    "description": "Sberbank",
    "textToTranslate": "payment-source.bank-transfer"
  },
  {
    "id": 9,
    "description": "ČSOB",
    "textToTranslate": "payment-source.bank-transfer"
  },
  null, null, null,
  {
    "id": 13,
    "description": "Unikasa",
    "textToTranslate": "payment-source.unikasa"
  },
  {
    "id": 14,
    "description": "Clearing/Banka",
    "textToTranslate": "payment-source.bank-transfer"
  },
  null, null, null, null, null, null, null, null, null, null,
  {
    "id": 25,
    "description": "Banka XML",
    "textToTranslate": "payment-source.bank-transfer"
  },
  null,
  {
    "id": 27,
    "description": "Poštová banka rec. súbor",
    "textToTranslate": "payment-source.epostal-order"
  }
]
